import React from 'react';

import ChildrenPropType from 'lib/CustomPropTypes/children';

function VideoListItems(props) {
  const { children } = props;

  return (
    <div className="ontheshow__video-list-items">
      { children }
    </div>
  );
}

VideoListItems.propTypes = {
  children: ChildrenPropType.isRequired,
};

export default VideoListItems;
